import $ from 'jquery';
import Popper from 'popper.js';
import Lang from 'lang.js';
import messages from './messages.json';

const lang = new Lang({
	messages: messages,
	locale: 'sk',
	fallback: 'en',
});

window.$ = window.jQuery = $;
window.Popper = Popper;
window.__ = (key, replacements, locale) => lang.get(key, replacements, locale);

import 'bootstrap';



// WEBPACK FOOTER //
// ./resources/js/init.js